import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Palette, Save } from 'lucide-react';

export default function AdminThemePage() {
  const [theme, setTheme] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => { try { const { data } = await api.get('/admin/settings'); setTheme(data.settings.theme || {}); } catch (e) {} finally { setLoading(false); } })(); }, []);

  const set = (k, v) => setTheme(p => ({ ...p, [k]: v }));

  const save = async () => {
    try { await api.put('/admin/settings', { settings: theme }); toast.success('Tema salvato!'); }
    catch (e) { toast.error('Errore'); }
  };

  if (loading) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div>;

  const ColorPick = ({ label, k }) => (
    <div className="flex items-center gap-3"><input type="color" value={theme[k] || '#000'} onChange={e => set(k, e.target.value)} className="w-10 h-10 rounded border border-gray-600 cursor-pointer" /><div><p className="text-sm text-white">{label}</p><p className="text-xs text-gray-500">{theme[k]}</p></div></div>
  );

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white flex items-center gap-2"><Palette size={24} className="text-yellow-400" />Personalizzazione Tema</h1>
        <button onClick={save} className="btn-admin inline-flex items-center gap-2"><Save size={16} />Salva</button>
      </div>
      <div className="card-dark p-6">
        <div className="grid grid-cols-2 gap-6">
          <ColorPick label="Colore Primario" k="primary_color" />
          <ColorPick label="Colore Secondario (Accento)" k="secondary_color" />
          <ColorPick label="Colore Terziario" k="accent_color" />
          <ColorPick label="Sfondo" k="bg_color" />
          <ColorPick label="Testo" k="text_color" />
        </div>
        <div className="mt-6"><label className="block text-xs text-gray-400 mb-1">Font</label><input className="input-field-dark" value={theme.font_family || ''} onChange={e => set('font_family', e.target.value)} placeholder="Plus Jakarta Sans" /></div>
      </div>
    </div>
  );
}
